<template>

  <div class="home">
    <div class="tRowTopMain" :class="{tRowTopMainnonMobile : isMobile(true) }">
        <MiniMenu 
          :config="config"
          :seasonCode="season"
          :tour="tour"
        />
    </div>
    <div class="container" style="margin-top:50px">
        <ReportHomeTab
            :tour="tour"
            :Year="season"
            :code="course"
            :codeT="code"
            :course_code="course_code"
            :reportURL="currentReport"
            :currentReport="reportTitle"
            :title="currentTitle"
            :config="config"
            :home="false"
            :tournDates="tournDates"
            :updateSize="updateSize"
            :widgetHeight="widgetHeight"
            :reports="reports"
            :tmparams="tm_params"
            :match="match"
            :listFinalAll='listFinalAll'
            :multi_tourns='multi_tourns'
            :dataerror='dataerror'
        />
    </div>
    <template v-if="tm_params.play_suspended == 'Y' && tm_params.live_message == 'N'">
      <div class="LiveScoreMessage" v-if="tm_params.play_suspended == 'Y'">
        <p v-if="tm_params.play_suspended == 'Y'">Play Suspended</p>
      </div>
    </template>
    <template v-else-if="tm_params.play_suspended == 'Y' && tm_params.live_message == 'Y'">
      <div class="LiveScoreMessage" >
        <p>
          Play Suspended<br>
          {{tm_params.live_scoring_mess}}
        </p>
      </div>
    </template>
    <template v-else-if="tm_params.play_suspended == 'N' && tm_params.live_message == 'Y'">
      <div class="LiveScoreMessage" :class="{suspendBkColor: tm_params.live_message == 'Y'}">
        <p>
          {{tm_params.live_scoring_mess}}
        </p>
      </div>
    </template>
  </div>
</template>
<script>
import apiCall from "@/services/api.js";
import ReportHomeTab from "@/components/reportsFull.vue";
import MiniMenu from "@/components/miniMenu.vue";
import axios from "axios";
export default {
  name: "Full Reports", 
  props: ['config'],
  components: { 
    ReportHomeTab,
    MiniMenu
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    return {
      title: [], //Page Title
      description: [], //Meta Description
      homepage: true,
      home: true,
      wphome: [],
      inter: "5",
      pro: "44",
      latestsm: "29",
      latestFull: "8",
      featHome: "true",
      reports: [],
      course: [],
      season: [],
      course_code: [],
      codeT: '',
      tm_params:[],
      mobWidget: process.env.VUE_APP_MOB_WIDGET,
      tour: process.env.VUE_APP_TOUR,
      match: '',
      listFinalAll: [],
      tournPrevCode: [],
      lastCode: '',
      cacheCode: 'aus'
    };
  },
  methods: {
    isMobile() {
      if (screen.width <= 500) {
        return true;
      } else {
        return false;
      }
    },
    tournList() {
      let id = this.season
      let code = 'aus'
      apiCall 
        .tmParamsYear(id, code)
        .then(({ data }) => {
          this.tournListing = data.tournaments.tournaments_entry;
          const arr = [];
          console.log("tournCodePrev--"); // 4
          console.log(arr); // 4
          this.tournListing.forEach((value) => {
            if (value.reports !== '') {
              arr.push(value.code);
            }
          });
          const last = arr.at(-1);
          console.log("last--"); // 4
          console.log(last); // 4
          this.lastCode = last;
          this.prevYear()
        })
    },
    prevYear() {
      let last = this.lastCode
      axios
        .get('https://api.aus.ocs-software.com/pgaaus/cache/aus/' + this.season + '/' + this.season + '-' + last + '-' + 'tmticx?randomadd=' +
              new Date().getTime())
        .then((response) => {
          this.tm_params = response.data;
          this.reports = response.data.reports.reports_entry;
          // console.log("this.reports")
          // console.log(this.reports)
          this.season = response.data.tm_params.season_code;
          this.course = response.data.code;
          this.codeT = response.data.code;
          this.course_code = response.data.course_code;
          this.tournDates = response.data.tourn_dates;
          this.match = response.data.match_play;
          this.name = response.data.short_name;
          this.firstArray = [
            {
              'name': this.name,
              'code': this.course,
            }
          ]
          this.pastTourns = response.data.past_tourns;
          this.futureTourns = response.data.future_tourns;
          if (this.pastTourns != '') {
            if (Array.isArray(response.data.past_tourns.past_tourns_entry)) {
              console.log("isArray");
              this.past_tourns = response.data.past_tourns.past_tourns_entry;
            } else {
              console.log("is not Array");
              this.past_tourns = [response.data.past_tourns.past_tourns_entry];
            }
            var listFinal =  this.firstArray.concat(this.past_tourns);
            this.listFinalAll = listFinal;          
          } else if (this.futureTourns !== '') {
            if (Array.isArray(response.data.future_tourns.future_tourns_entry)) {
              console.log("isArray");
              this.past_tourns = response.data.future_tourns.future_tourns_entry;
            } else {
              console.log("is not Array");
              this.past_tourns = [response.data.future_tourns.future_tourns_entry];
            }
            var listFinals=  this.firstArray.concat(this.past_tourns);
            this.listFinalAll = listFinals;
          }
          this.multi_tourns = response.data.multi_tourns;    
        })
    },
  //   updateSize:function() {
  //     // const windowWidth = window.innerWidth;
  //     // this.NewWidgetHeight = window.innerHeight;
  //     // console.log("this.NewWidgetHeight")
  //     // console.log(this.NewWidgetHeight)

  //     // if (windowWidth < '400' && windowWidth > '311') {
  //     //   this.widgetHeight = '554px'
  //     // } else if(windowWidth < '311') {
  //     //   this.widgetHeight = '491px'
  //     // } else if(windowWidth > '401') {
  //     //   this.widgetHeight = '669px'
  //     // }
  //   }
  },
  mounted() {
    // this.updateSize();
    // window.addEventListener('resize', this.updateSize);
    // window.addEventListener('scroll', this.updateSize);
    axios //add API Call
      .get(
        process.env.VUE_APP_WPAPI_URL+"wp/v2/pages/202?randomadd=" +
          new Date().getTime()
      )
      .then((response) => (this.wphome = response.data));
  },
  
  computed: {
    filterReport: function() {
      if (Array.isArray(this.reports)) {
        return this.reports.filter(
          (reports_entry) =>
            reports_entry.report_title.includes("Tournament Entries") ||
            // reports_entry.report_title == 'Round 1 Draw' ||
            reports_entry.report_title.includes("Score") ||
            // reports_entry.report_title.includes("Live") ||
            reports_entry.report_title.includes("Final Result")
        );
      } else return this.reports; 
    },

    currentReport() {
      if (Array.isArray(this.filterReport))
        return this.filterReport[this.filterReport.length - 1].report_url;
      else return this.reports.report_url;
    },
    currentTitle() {
      if (Array.isArray(this.filterReport))
        return this.filterReport[this.filterReport.length - 1].report_title;
      else return this.reports.report_title;
    },
    reportTitle: function(url) {
      if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          this.config.VUE_APP_TIC_BASE +
          this.config.VUE_APP_AUS +
          "/" +
          this.tm_params.tm_params.season_code +
          "/" +
          this.tm_params.tm_params.season_code +
          "-" +
          this.codeT +
          "-entryw-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.currentReport.indexOf("tmscore") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );
          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
              this.config.VUE_APP_TIC_BASE +
              this.config.VUE_APP_AUS +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.codeT +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
          } else {
            url =
              this.config.VUE_APP_TIC_BASE +
              this.config.VUE_APP_AUS +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.codeT +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
          }
        } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
          {
            url =
              this.config.VUE_APP_TIC_BASE +
              this.config.VUE_APP_AUS +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.codeT +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
          }
        } else if (this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            this.config.VUE_APP_TIC_BASE +
            this.config.VUE_APP_AUS +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.codeT +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.currentReport.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          if (this.tm_params.team_scoreboard_only == 'N') {
             resNum1 = 'PF'
          } else {
            resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          }
          console.log("resNum === ");
          console.log(resNum1);
          url =
            this.config.VUE_APP_TIC_BASE +
            this.config.VUE_APP_AUS +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.codeT +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            this.config.VUE_APP_TIC_BASE +
            this.config.VUE_APP_AUS +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.codeT +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    },
  },
  //  metaInfo() {
  //    //Injects Meta and Title to Head
  //    return {
  //      title: this.title.content,
  //      meta: [
  //        {
  //          name: this.description.name,
  //          content: this.description.content
  //        }
  //      ]
  //    };
  //  },
  created() {
    setInterval(
      console.log('In Interval 270'),
      this.updateSize, 12000,
      console.log('In Interval 272')
    );
    apiCall 
      .tmParamsBase(this.cacheCode)
      .then(({ data }) => {
        this.season = data.tm_params.season_code;
        if (data.error_reason == 'Tournament master record missing(    )' || data.reports == '') {
          this.tournList();
          // this.prevYear();
        } else {
          this.tm_params = data;
          this.reports = data.reports.reports_entry;
          this.season = data.tm_params.season_code;
          this.course = data.code;
          this.codeT = data.code;
          this.course_code = data.course_code;
          this.tournDates = data.tourn_dates;
          this.match = data.match_play;
          this.name = data.short_name;
          this.firstArray = [
            {
              'name': this.name,
              'code': this.course,
            }
          ]
          this.pastTourns = data.past_tourns;
          this.futureTourns = data.future_tourns;
          if (this.pastTourns != '') {
            if (Array.isArray(data.past_tourns.past_tourns_entry)) {
              console.log("isArray");
              this.past_tourns = data.past_tourns.past_tourns_entry;
            } else {
              console.log("is not Array");
              this.past_tourns = [data.past_tourns.past_tourns_entry];
            }
            var listFinal =  this.firstArray.concat(this.past_tourns);
            this.listFinalAll = listFinal;          
          } else if (this.futureTourns !== '') {
            if (Array.isArray(data.future_tourns.future_tourns_entry)) {
              console.log("isArray");
              this.past_tourns = data.future_tourns.future_tourns_entry;
            } else {
              console.log("is not Array");
              this.past_tourns = [data.future_tourns.future_tourns_entry];
            }
            var listFinals=  this.firstArray.concat(this.past_tourns);
            this.listFinalAll = listFinals;
          }
          this.multi_tourns = data.multi_tourns;      
        }                
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>
<style scoped>
.suspendBkColor {
  background-color: blue!important;
}
.LiveScoreMessage {
  /* position: sticky;
  bottom: 0; */
  position: fixed;
  top: 0;
  background: red;
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 999;
}
.LiveScoreMessage > p {
  margin-bottom: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.tRowTopMainnonMobile {
  background-color: transparent!important;
}
.tRowTopMain {
  background-color: rgba(0, 0, 0, 0.04);
}
::v-deep .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: transparent;
}
::v-deep .tabone {
  width: 27%;
}
::v-deep .tabtwo {
  width: 40%;
}
::v-deep .tabthree {
  width: 33%;
}
.homeReport-list {
  /* height: 669px; */
}
.HomehomeReport-list {
  border: 1px solid #E6E6E6;
}
::v-deep li.nav-item.tabsStyle {
  /* width: 33%; */
}
::v-deep li.nav-item.tabsStyle > a{
  /* padding-left: 13px!important;
  padding-right: 10px!important; */
}
/* ::v-deep .nav-tabs .nav-link:hover {
  cursor: default;
  background-color: #dfe1e6;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  color: #00433e !important;
  padding-left: 18px;
  padding-right: 20px;
  text-align: center;
} */
/* ::v-deep .nav-tabs .nav-link.active {
  cursor: default;
  background-color: #fff;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  color: #34caa9 !important;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
} */
/* ::v-deep .nav-tabs .nav-link {
  cursor: default;
  background-color: #E6E6E6;
  color: #B8B8B8 !important;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  text-align: center;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
} */
::v-deep .nav-tabs {
    border-bottom: 0px solid #dee2e6;
}
/* ::v-deep .tabWhite {
  padding-top: 0em;
  height: 581px;
} */
.home {
  background-color: #fff;
}
.title {
  font-weight: 500;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  color: #000;
  font-size: 23pt;
  margin-top: 1em;
  line-height: 1.1;
  /* letter-spacing: 2px; */
}

.ad {
  padding: 15px 0; 
}

.bottomAdBanner {
  width: 100%;
}
.sections {
  padding: 30px 0;
}
.box {
  display: block;
  top: 0px;
  border-radius: 4px;
  position: relative;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
}

.box:hover {
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
  top: -4px;
  background-color: white;
}
@media only screen and (max-height: 1024px) {
  .homeReport-list {
    /* height: auto !important; */
  }
}
@media only screen and (max-height: 430px) {
::v-deep .nav-tabs .nav-link.active {
  cursor: default;
  background-color: #fff;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  color: #34caa9 !important;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  padding-top: 15px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs .nav-link {
  cursor: default;
  background-color: #E6E6E6;
  color: #B8B8B8 !important;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  text-align: center;
  padding-top: 15px;
  padding-bottom: 35px;
  border: none!important;
}
}
.mobWidgetPad {
  height: 450px!important;
}
@media only screen and (max-width: 480px) {
  .bottomAdBanner{
    padding: 15px 0;
  }
}

@media only screen and (max-width: 419px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 100;
    font-style: normal;
    font-size: 13px;
    color: white !important;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    background-color: #003c52;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
  }
}
</style>
